import {
  COUNTRIES
} from "./chunk-6NFYDIYU.mjs";
import {
  iso2FlagEmoji
} from "./chunk-6R6ETMZO.mjs";
import {
  input_default
} from "./chunk-SDBF3NFL.mjs";
import {
  ChevronDown_default
} from "./chunk-KC3324ST.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/phone-input/CountrySelect.tsx
import { useCombobox } from "downshift";
import React, { useEffect, useState } from "react";
var selectOptions = Object.values(COUNTRIES).map(
  (item) => item
);
var filterSelectOptionsByInputValue = (inputValue) => {
  return selectOptions.filter((item) => {
    const lowerCaseInput = inputValue.toLowerCase();
    const labelMatch = ((item == null ? void 0 : item.label) || "").toLowerCase().startsWith(lowerCaseInput);
    const idMatch = ((item == null ? void 0 : item.id) || "").toLowerCase().startsWith(lowerCaseInput);
    const dialCodeMatch = ((item == null ? void 0 : item.dialCode) || "").includes(lowerCaseInput);
    return labelMatch || idMatch || dialCodeMatch;
  });
};
var CountrySelect = ({
  countryCode,
  onCountryChange,
  inputRef = { current: null },
  ariaLabel,
  maxDropdownHeight = 200
}) => {
  const [countries, setCountries] = useState(selectOptions);
  const [countryFilterInputValue, setCountryFilterInputValue] = useState("");
  const onCountryFilterInputValueChange = (e) => {
    const inputValue = e.target.value;
    setCountryFilterInputValue(inputValue);
    setCountries(filterSelectOptionsByInputValue(inputValue));
    setHighlightedIndex(0);
  };
  const {
    isOpen,
    getComboboxProps,
    getInputProps,
    selectedItem,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
    setHighlightedIndex,
    selectItem
  } = useCombobox({
    items: countries,
    itemToString: () => "",
    defaultSelectedItem: countryCode ? COUNTRIES[countryCode] : void 0,
    onSelectedItemChange: (changes) => {
      onCountryChange == null ? void 0 : onCountryChange(changes);
    },
    scrollIntoView() {
      return "";
    },
    stateReducer: (_state, actionAndChanges) => {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useCombobox.stateChangeTypes.FunctionCloseMenu:
          return __spreadProps(__spreadValues({}, changes), {
            inputValue: ""
          });
        case useCombobox.stateChangeTypes.ItemClick:
          if (inputRef && inputRef.current) {
            inputRef.current.focus();
          }
          return changes;
        default:
          return changes;
      }
    }
  });
  useEffect(() => {
    if (countryCode) {
      selectItem(COUNTRIES[countryCode]);
    }
  }, [countryCode, selectItem]);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", __spreadValues({}, getComboboxProps()), /* @__PURE__ */ React.createElement(
    "div",
    __spreadProps(__spreadValues({
      "aria-label": ariaLabel
    }, getToggleButtonProps()), {
      className: "flex h-full w-full cursor-pointer items-center overflow-hidden rounded bg-clip-border outline-none my-body-md"
    }),
    /* @__PURE__ */ React.createElement("div", { className: "relative inline-block" }, /* @__PURE__ */ React.createElement("div", { className: "flex w-full overflow-hidden my-body-md" }, /* @__PURE__ */ React.createElement("div", { className: "relative flex flex-shrink-0 flex-grow items-center self-stretch py-2 pr-0" }, /* @__PURE__ */ React.createElement("div", { className: "my-heading-xl", "aria-hidden": "true" }, iso2FlagEmoji(selectedItem == null ? void 0 : selectedItem.id))), /* @__PURE__ */ React.createElement("div", { className: "relative flex flex-shrink-0 items-center self-stretch pl-1 pr-0" }, /* @__PURE__ */ React.createElement(ChevronDown_default, { width: 18 })))),
    /* @__PURE__ */ React.createElement(
      "input",
      __spreadProps(__spreadValues({}, getInputProps()), {
        className: "w-[1px] appearance-none border-transparent bg-transparent text-transparent caret-transparent outline-none",
        autoComplete: "off",
        "aria-label": "Select country",
        "aria-autocomplete": "list",
        "aria-expanded": "false",
        "aria-haspopup": "false",
        role: "combobox",
        tabIndex: 0
      })
    ),
    /* @__PURE__ */ React.createElement("div", { className: "ml-1 flex items-center" }, selectedItem == null ? void 0 : selectedItem.dialCode)
  )), /* @__PURE__ */ React.createElement("div", { className: "absolute left-0 right-0 z-10" }, /* @__PURE__ */ React.createElement(
    "ul",
    __spreadValues({
      className: cn(
        "relative m-0 mt-1 list-none overflow-auto rounded bg-surface px-0 py-2 shadow-lg ring-1 ring-black/5 focus:outline-none",
        {
          "hidden opacity-0": !isOpen,
          "visible opacity-100": isOpen
        }
      ),
      style: {
        maxHeight: maxDropdownHeight,
        transform: "translate(0, calc(-100% - 4px))"
      }
    }, getMenuProps()),
    isOpen && /* @__PURE__ */ React.createElement(
      input_default,
      {
        className: { container: "m-2" },
        placeholder: "Type country to filter",
        value: countryFilterInputValue,
        onChange: onCountryFilterInputValueChange
      }
    ),
    isOpen && countries.map((item, index) => /* @__PURE__ */ React.createElement(
      "li",
      __spreadValues({
        key: index,
        className: cn(
          "transitions-bg relative flex w-full cursor-pointer select-none items-center py-2 text-foreground duration-300 ease-out my-body-sm",
          { "bg-interactive-surface": highlightedIndex === index }
        )
      }, getItemProps({
        item,
        index
      })),
      /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "items-center pl-4" }, /* @__PURE__ */ React.createElement("div", { className: "my-heading-xl" }, iso2FlagEmoji(item.id))), /* @__PURE__ */ React.createElement("div", { className: "truncate pl-4" }, item.label), /* @__PURE__ */ React.createElement("div", { className: "ml-auto pr-4" }, item.dialCode))
    )),
    isOpen && countries.length === 0 && /* @__PURE__ */ React.createElement("li", { className: "cursor-not-allowed px-4 py-3 text-center" }, /* @__PURE__ */ React.createElement("div", { "aria-label": "Loading", className: "text-foreground-subtle" }, "No results"))
  )));
};

export {
  CountrySelect
};
